export var isShowPhoneImmediately = function isShowPhoneImmediately(_ref) {
  var builders = _ref.builders,
    sellers = _ref.sellers,
    isLeadFactory = _ref.isLeadFactory,
    withoutModal = _ref.withoutModal;
  var moreThanOnePhone = builders.length + sellers.length > 1;
  if (moreThanOnePhone) {
    return false;
  }
  return withoutModal || builders.length > 0 && !isLeadFactory;
};